import React, {useContext, useState} from 'react';
import {Context} from "../store/reducer";

const Component = () => {

    const { state, dispatch } = useContext(Context);
    let [isOpened, setIsOpened] = useState(true);

    /**
     * 同意した場合は二重チェック用のフラグをtrueにする。
     */
    const agree = () => {

        dispatch({
            type    : 'SET_VIS93_MODAL_AGREE',
            category: "vis_93_1"
        })
        dispatch({
            type    : 'SET_VIS93_MODAL_AGREE',
            category: "vis_93_2"
        })
        dispatch({
            type    : 'SET_VIS93_MODAL_AGREE',
            category: "vis_93_3"
        })
        
        setIsOpened(false)
    }
    
    const disAgree = () => {
        setIsOpened(false)
    }

    return (isOpened && <>
        <div class="modal-first">
            <div class="modal-first-inner">

                <h3 className="u-fs-16 u-txt-c u-pb-xs u-lh-sm">建築基準法施行規則第10条の２に規定する『指定道路図』（参考図）を公開します。</h3>

                <section className="u-pb-xs">
                    <h5 style={{}}>公開対象道路<br />
                        次の指定道路の種類について、調査済の道路を公開します。</h5>
                    <ol className="p-number-list u-lh-sm">
                        <li>
                            <span className="u-fs-12">
                                ４号道路（建築基準法第42条第１項第４号）
                            </span>
                        </li>
                        <li>
                            <span className="u-fs-12">
                                ５号道路【位置指定道路】（建築基準法第42条第１項第５号）
                            </span>
                        </li>
                        <li>
                            <span className="u-fs-12">
                                ２項道路（建築基準法第42条第２項）
                            </span>
                        </li>
                    </ol>
                </section>



                <section className="u-pb-xs">
                    <h4 className="u-fs-14 u-pb-xxs u-lh-sm" style={{fontWeight: "bolder"}}>公開対象の市町（県管轄）</h4>
                    <div className="u-fs-12 u-lh-sm u-pb-sm">
                        <p className="u-pb-xs">竹原市・府中市・庄原市・大竹市・安芸高田市・江田島市・府中町・海田町・熊野町・坂町・北広島町・世羅町</p>
                        <p>
                            <a href="https://www.pref.hiroshima.lg.jp/soshiki/107/shiteidouro.html">https://www.pref.hiroshima.lg.jp/soshiki/107/shiteidouro.html</a>
                        </p>
                    </div>

                    <div className="u-pb-xs">
                        <h5>［「指定道路図」ご利用上の注意］<br />
                            ご利用に際しましては、次の記載事項の内容に同意の上、閲覧してください。
                        </h5>
                        <ul className="u-fs-12">
                            <li>１．この指定道路図（以下「本図」という。）は参考図であり、建築基準法施行規則第10条の２に規定する「指定道路図」ではありません。正確な情報が必要な場合は、所管する各建設事務所建築課の窓口においてご確認ください。</li>
                            <li>２．本図は、次の資料として用いることは出来ません。<br />
                                （１）建築基準法第43条に規定する敷地等と道路との関係を判断する資料<br />
                                （２）土地の所有権境を判断する資料<br />
                                （３）権利義務発生するもの、不動産取引のための資料<br />
                            </li>
                            <li>３．本図は、表示している内容を証明するものではありません。参考図としてご利用ください。</li>
                            <li>４．本図は、建築基準法施行規則第10条に規定する指定道路（以下、「指定道路」という。）のおおむねの位置及び種類を表示したものであり、道路の幅員、境界位置、起点・終点、位置などの道路の形状を示したものではありません。</li>
                            <li>５．本図は、現時点までの調査による指定道路を表示しており、随時更新して追加していきます。</li>
                            <li>６．本図は、地図の精度上及びデータ入力上の誤差を含んでいます。</li>
                            <li>７．本図は、最新の地図情報ではないため、現況と異なる場合があります。</li>
                            <li>８．本図は、予告無く内容を変更する場合がありますので、必ず最新の情報を所管する各建設事務所建築課でご確認ください。</li>
                            <li>９．本図の全部または一部を無断で複写、複製、転載、ファイル化し利用することを禁じます。</li>
                            <li>10．本図に関して、Tel、Fax、メール等によるお問い合わせについては、お答え出来ませんので、所管する各建設事務所建築課の窓口にてお願いします。</li>
                            <li>11．広島県は、本図の利用により発生する直接又は間接の損失・損害等について、一切の責任を負いません。</li>
                        </ul>

                        
                        
                        
                        
                        
                        
                        
                        
                        
                        
                        
                        
                        
                        
                    </div>
                </section>
                
                <h4>上記利用上の注意事項について、全て同意しますか。</h4>

                <p className="u-txt-c" onClick={agree} style={{ cursor: 'pointer' }} ><span style={{"text-decoration": "underline"}}>同意します</span></p>
                <p className="u-txt-c" onClick={disAgree} style={{fontSize:"0.7em", cursor: 'pointer' }}><span style={{"text-decoration": "underline"}}>同意しません</span></p>
            </div>
        </div>
    </>);
}

export default Component
